import React from 'react'
import Header from '../_components/common/Header'
import ClassUI from '../_components/UI/ClassUI'

const ClassSummary = () => {
  return (
    <div className='page-main'>
        <Header name = {["Class Summary"]}  />
        <ClassUI />
    </div>
  )
}

export default ClassSummary